import { render, staticRenderFns } from "./ModelBuild.vue?vue&type=template&id=8aeb4ce8&scoped=true&"
import script from "./ModelBuild.vue?vue&type=script&lang=ts&"
export * from "./ModelBuild.vue?vue&type=script&lang=ts&"
import style0 from "./ModelBuild.vue?vue&type=style&index=0&id=8aeb4ce8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeb4ce8",
  null
  
)

export default component.exports